import { createContext, useContext } from 'react'
import { OrderDetail_OrderFragmentFragment, OrderDetailQuery } from '../../gql/graphql'
import { EntityResponse, FragmentValue, ItemOfEntityResponse } from '../../lib/RequestUtils'
import { graphql } from '../../gql/gql'
import { FragmentType } from '../../gql'

// Context to provide "server-state" of order

// TODO: Write a guide to the fragments and how to use them

// in two words:
// - define a order fragment in every component that uses orderDetailContext and pass it here,
// it will add this fragment to the final request and generate all needed ts types

const OrderDetail_OrderFragment = graphql(`
  fragment OrderDetail_OrderFragment on Order {
    id
    ...EditExpeditionBatchPositionModal_OrderFragment
    ...ClearanceItemsInTable_OrderFragment
    ...PickingCheckboxCell_OrderFragment
    ...OrderReturns_OrderFragment
    ...OrderProducts_OrderFragment
    ...OrderItemsTable_OrderFragment
    ...Footer_OrderFragment
    ...PackingCheckboxCell_OrderFragment
    ...CarrierCurrencyPayment_OrderFragment
    ...PackageDetail_OrderFragment
    ...ReturnAllModal_OrderFragment
    ...EditReturnItemModal_OrderFragment
    ...OrderItemsInPackages_OrderFragment
    ...OrderInfo_OrderFragment
    ...OrderStateHistory_OrderFragment
    ...OrderDetailsInfo_OrderFragment
    ...OrderFiles_OrderFragment
    ...OrderHeader_OrderFragment
    ...UseOrderPicking_OrderFragment
    ...OrderListItem_Order # for adding to history
  }
`)

export interface OrderDetailContextType {
  order: FragmentValue<typeof OrderDetail_OrderFragment> | null
}

const defaultOrderDetail: OrderDetailContextType = {
  order: null,
}

export const useOrderDetailContext = () => {
  return useContext(OrderDetailContext)
}

export const OrderDetailContext = createContext<OrderDetailContextType>(defaultOrderDetail)
